import { CapicheLoggerCore } from '@capiche/ts-logger-core';

// src/ng-workspace/projects/capiche-ui/src/lib/utils/component-instance-tracker.ts
export class ComponentInstanceTracker {
  private static logger = new CapicheLoggerCore('component-instance-tracker:', false);
  private static counts: Record<string, number> = {};
  private static srcCounts: Record<string, number> = {};
  private static debounceTimer: any;

  static increment(name: string) {
    this.counts[name] = (this.counts[name] || 0) + 1;
    this.scheduleLog('increment');
  }

  static decrement(name: string) {
    this.counts[name] = Math.max((this.counts[name] || 0) - 1, 0);
    this.scheduleLog('decrement');
  }

  private static scheduleLog(s: string) {
    this.srcCounts[s] = (this.srcCounts[s] || 0) + 1;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.logger.log('counts: ', { ...this.srcCounts }, { ...this.counts });
      this.srcCounts = {};
    }, 100); // 100ms debounce
  }
}
